module.exports = __webpack_public_path__ + "img/国家认证 资质齐全.8ab08e78.png";